import React from 'react';
import { Button } from 'primereact/button';
import { Tag } from 'primereact/tag';
import { formatDateOnlyLong, formatDateTimePanama } from '../utils/agendaDates';

const AgendaStatusBanner = ({
    agenda,
    activeVisitCount,
    selectedWeekStart,
    selectedWeekEnd,
    isPast,
    isCurrent,
    isFuture,
    isAdmin,
    canSubmit,
    submitting,
    onSubmit,
    deadlineLabel = 'sábado a las 23:59'
}) => {
    let title = isFuture ? 'Semana futura disponible para planificar' : 'Agenda semanal';
    let text = isFuture
        ? `Puedes agregar citas del ${formatDateOnlyLong(selectedWeekStart)} al ${formatDateOnlyLong(selectedWeekEnd)}, aunque falten varias semanas.`
        : `Visitas del ${formatDateOnlyLong(selectedWeekStart)} al ${formatDateOnlyLong(selectedWeekEnd)}.`;
    let tag = <Tag value="No iniciada" severity="secondary" />;

    if (isPast) {
        title = 'Semana cerrada · Solo lectura';
        text = 'Esta semana ya cerró y no permite nuevas acciones de planificación.';
        tag = <Tag value="Solo lectura" severity="secondary" />;
    } else if (agenda?.status === 'submitted') {
        if (agenda?.reviewStatus === 'reviewed') {
            title = 'Agenda semanal revisada';
            text = agenda?.reviewComment || 'El supervisor revisó esta planificación.';
            tag = <Tag value="Revisada" severity="success" />;
        } else {
            title = 'Agenda semanal enviada';
            text = 'La planificación fue enviada y está pendiente de revisión.';
            tag = <Tag value="Enviada · Pendiente de revisión" severity="info" />;
        }
    } else if (agenda?.status === 'notSubmitted') {
        title = 'No se envió agenda semanal';
        text = 'Existen actividades registradas para esta semana, pero no hubo una agenda enviada formalmente.';
        tag = <Tag value="No enviada" severity="danger" />;
    } else if (agenda?.status === 'draft') {
        if (agenda?.reviewStatus === 'returned') {
            title = 'Agenda devuelta para ajustes';
            text = agenda?.reviewComment || 'El supervisor solicitó ajustes antes de reenviar la agenda.';
            tag = <Tag value="Devuelta" severity="danger" />;
        } else {
            title = 'Agenda semanal en borrador';
            text = 'Tus cambios están guardados, pero todavía debes enviar la agenda.';
            tag = <Tag value="Borrador" severity="warning" />;
        }
    } else if (isCurrent) {
        title = 'No se encontró una agenda enviada para esta semana';
        text = 'Cuando exista una agenda enviada para esta semana aparecerá aquí.';
        tag = <Tag value="Sin agenda" severity="warning" />;
    } else if (isFuture) {
        tag = <Tag value="Disponible" severity="success" />;
    }

    return (
        <div className="surface-card border-round p-3 shadow-1 ventas-status-banner">
            <div className="flex flex-column lg:flex-row lg:align-items-center lg:justify-content-between gap-3">
                <div>
                    <div className="flex align-items-center gap-2 flex-wrap mb-2">
                        <h3 className="m-0">{title}</h3>
                        {tag}
                    </div>
                    <p className="text-color-secondary mt-0 mb-0">{text}</p>
                    {isAdmin && !isPast ? <p className="text-sm text-color-secondary mt-2 mb-0">Modo administrador: las semanas futuras están disponibles; la semana actual depende del ajuste administrativo.</p> : null}
                </div>

                <div className="ventas-status-meta">
                    {agenda?.status === 'submitted' ? <span>Enviada: {formatDateTimePanama(agenda.submittedAt)}</span> : <span>Entrega sugerida: {deadlineLabel}</span>}
                    <span>{activeVisitCount} visitas planificadas</span>
                    {canSubmit ? <Button type="button" label="Enviar agenda" icon="pi pi-send" onClick={onSubmit} loading={submitting} disabled={submitting} /> : null}
                </div>
            </div>
        </div>
    );
};

export default AgendaStatusBanner;
